import React, { Component } from 'react'

import './Rotation.css'

/* Modules */
import { message } from 'antd'

/* Components */
import RotationView from './RotationView';
import { getARotationFromChamp, updateARotationFromChamp } from '../../utils/confrontationsFunctions';

class Rotation extends Component {

    constructor(props) {
        super(props)
        this.state = {
            champObject: '',
            champId: null,
            rotationId: null,
            isScoreMan: false,

            rotationTempObject: {
                competitors: [{ nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }],
                arrayOfTeams: []
            },

            rotation: [{ nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }],

            arrayOfTeams: [],
            arrayOfTeamsWithScore: [],
            ranking: ['', '', ''],

            pageToGo: '',

            loading: true,
            loadingRotation: true,
            loadingSave: false
        }
    }

    componentWillMount = () => {
        this.setState({
            champObject: this.props.champObject,
            champId: this.props.champId,
            rotationId: this.props.rotationId,
            isScoreMan: this.props.isScoreMan
        })
        this.renderRotation(this.props.rotationId, this.props.isScoreMan, this.props.champId)
    }

    componentWillReceiveProps = (nextProps) => {
        this.setState({
            champObject: nextProps.champObject,
            champId: nextProps.champId,
            rotationId: nextProps.rotationId,
            isScoreMan: nextProps.isScoreMan
        })
        this.renderRotation(nextProps.rotationId, nextProps.isScoreMan, nextProps.champId)
    }

    renderRotation = async (id, isScoreMan, champKey) => {
        this.setState({ loadingRotation: true })

        /* Get all competitors and teams */
        let localArrayOfCompetitors = JSON.parse(sessionStorage.getItem('rotationArrayOfCompetitors'))
        let localArray = JSON.parse(sessionStorage.getItem('rotationArrayOfTeams'))

        if (localArrayOfCompetitors && localArray) {
            this.setState({
                filteredArrayOfStudents: localArrayOfCompetitors,
                loading: false,
            })
        }

        /* Empty rotations */
        this.setState({
            rotation: [{ nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }],
            rotationTempObject: {
                competitors: [{ nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }],
                arrayOfTeams: []
            },
            arrayOfTeamsWithScore: [],
            ranking: ['', '', ''],

            // Render options to create rotation
            isScoreMan: isScoreMan,
        })

        /* Get all confrontations */
        if (id && champKey) {
            const rotation = await getARotationFromChamp(champKey, id.toString());
            if (rotation) {
                this.setState({ rotationTempObject: rotation })
                if (rotation.competitors) {
                    let localRotation = [{ nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }]
                    for (let i = 0; i < rotation.competitors.length; i++) {
                        localRotation[i] = rotation.competitors[i]
                    }

                    // Get index of competitor
                    for (let i = 0; i < localRotation.length; i++) {
                        if (localRotation[i]) {
                            let count = 0
                            localArrayOfCompetitors.forEach(competitor => {
                                if (competitor.__key === localRotation[i].__key) {
                                    localRotation[i]['index'] = count
                                }
                                count++
                            })
                        }
                    }

                    this.setState({ rotation: localRotation })

                    if (rotation.competitors[4].hasWon) {
                        this.buildScore(rotation)
                    }
                }

                if (rotation.arrayOfTeams)
                    this.setState({ arrayOfTeamsWithScore: rotation.arrayOfTeams })

                /* Close Loading Icon */
                this.setState({ loadingRotation: false })
            } else {
                this.setState({ loadingRotation: false })
            }
        } else { this.setState({ loadingRotation: false }) }
    }

    /* Put student in the selected index of switching */
    putStudentInRotation = (index, position) => {

        let competitor = this.state.filteredArrayOfStudents[index]

        /* Create competitor that will be added */
        let localCompetitor = {
            __key: competitor.__key,
            apto: competitor.apto,
            equipe: competitor.equipe,
            faixa: competitor.faixa,
            idade: competitor.idade,
            nome: competitor.nome,
            peso: competitor.peso,
            pesoQtd: competitor.pesoQtd,
            sexo: competitor.sexo,
            wasDeleted: competitor.wasDeleted
        }

        /* Get all infos of rotation */
        let localRotation = this.state.rotationTempObject

        /* Update local rotation */
        localRotation['competitors'][position] = Object.assign(localRotation['competitors'][position], localCompetitor)

        let localRotationToUpdate = this.state.rotation
        localRotationToUpdate[position] = localCompetitor

        this.setState({
            rotationTempObject: localRotation,
            rotation: localRotationToUpdate
        })

        if (position === 2) {
            /* Create array of teams */
            this.setState({ rotation: localRotation['competitors'] })
            this.createArrayOfTeams()

            /* Clear all confrontations */
            let localArrayOfCompetitors = this.state.rotation
            localArrayOfCompetitors = localArrayOfCompetitors.slice(0, 3)
            delete localArrayOfCompetitors[0].hasWon
            delete localArrayOfCompetitors[1].hasWon
            delete localArrayOfCompetitors[2].hasWon

            let localRotationToUpdate = this.state.rotationTempObject
            localRotationToUpdate['competitors'] = [localArrayOfCompetitors[0], localArrayOfCompetitors[1], localArrayOfCompetitors[2], { nome: '' }, { nome: '' }, { nome: '' }]
            this.setState({
                rotationTempObject: localRotationToUpdate,

                /* Clear ranking */
                ranking: ['', '', '']
            })
        }
    }

    /**
     * Methods to build score of teams and competitor
     */
    buildScore = (rotation) => {
        let localArrayOfTeamsScored = [], localArrayOfRanking = ['', '', '']

        /* Get who won in final and semifinals and score them */
        if (this.state.rotationId) {
            let localIndex = 0
            if (rotation) {
                rotation.competitors.forEach(competitor => {
                    if (((localIndex === 2 || localIndex === 3) && !competitor.hasWon) || localIndex > 3) {
                        localArrayOfTeamsScored.push({ team: competitor.equipe, score: competitor.score })

                        /* Create array of ranking */
                        if ((localIndex === 2 || localIndex === 3) && !competitor.hasWon)
                            localArrayOfRanking[2] = competitor.nome
                        else if (localIndex > 3) {
                            if (competitor.hasWon)
                                localArrayOfRanking[0] = competitor.nome
                            else
                                localArrayOfRanking[1] = competitor.nome
                        }
                    }
                    localIndex++
                })
                this.setState({ ranking: localArrayOfRanking })
            }

            /* Put score in array of team */
            let finalArrayOfTeamScored = []

            for (let j = 0; j < this.state.arrayOfTeamsWithScore.length; j++) {
                finalArrayOfTeamScored.push(this.state.arrayOfTeamsWithScore[j])
                let sumOfScore = 0
                for (let i = 0; i < localArrayOfTeamsScored.length; i++) {
                    if (localArrayOfTeamsScored[i].team === this.state.arrayOfTeamsWithScore[j].team) {
                        sumOfScore += localArrayOfTeamsScored[i].score
                    }
                }
                finalArrayOfTeamScored[j].score = sumOfScore
            }

            let localArrayToPush = this.state.rotationTempObject
            localArrayToPush['arrayOfTeams'] = finalArrayOfTeamScored

            /* Put object updated in firebase || Função em stand by */
            /*
            firebase.firestore().collection('champs').doc(this.props.location.state.__key).collection('rotation').doc(this.props.match.params.rotationId.toString())
            .update(localArrayToPush)
            */
            this.setState({ rotationTempObject: localArrayToPush })
        }
    }

    /* create array of teams */
    createArrayOfTeams = () => {
        let localArrayOfTeams = [], localArrayOfTeamsScored = []
        for (let i = 0; i < 3; i++) {
            let isANewTeam = true
            for (let j = 0; j < i; j++) {
                if (this.state.rotation[j].equipe === this.state.rotation[i].equipe) {
                    isANewTeam = false
                    break
                }
            }
            if (isANewTeam) {
                localArrayOfTeams.push(this.state.rotation[i].equipe)
                localArrayOfTeamsScored.push({ team: this.state.rotation[i].equipe, score: 0 })
            }
        }
        this.setState({ arrayOfTeams: localArrayOfTeams })

        /* create array of competitors per team */
        let localArrayOfCompetitorsPerTeam = []
        let indexOfTeam = 0
        for (let j = 0; j < 3; j++) {
            for (let i = 0; i < 3; i++) {
                let isANewCompetitor = true
                for (let k = 0; k < localArrayOfCompetitorsPerTeam.length; k++) {
                    if (this.state.rotation[i].__key === localArrayOfCompetitorsPerTeam[k].__key) {
                        isANewCompetitor = false
                        break
                    }
                }
                if (isANewCompetitor) {
                    if (this.state.rotation[i].equipe === this.state.rotation[indexOfTeam]) {
                        localArrayOfCompetitorsPerTeam.push(this.state.rotation[i])
                        if (indexOfTeam !== localArrayOfTeams.length - 1) {
                            indexOfTeam++
                        } else {
                            indexOfTeam = 0
                        }
                        break
                    }
                }
            }
        }
        if (localArrayOfCompetitorsPerTeam.length !== 3) {
            for (let j = 0; j < 3; j++) {
                let localHasCompetitor = false
                for (let i = 0; i < localArrayOfCompetitorsPerTeam.length; i++) {
                    if (localArrayOfCompetitorsPerTeam[i].__key === this.state.rotation[j].__key) {
                        localHasCompetitor = true
                        break
                    }
                }
                if (!localHasCompetitor) {
                    localArrayOfCompetitorsPerTeam.push(this.state.rotation[j])
                    break
                }
            }
        }

        let localRotationToUpdate = this.state.rotationTempObject
        localRotationToUpdate['arrayOfTeams'] = localArrayOfTeamsScored
        this.setState({ rotationTempObject: localRotationToUpdate })
    }

    /* Clear all rotations */
    clearRotation = () => {
        this.setState({
            arrayOfTeams: [],
            arrayOfTeamsWithScore: [],
            ranking: ['', '', ''],
            rotationTempObject: {
                arrayOfTeams: [],
                competitors: [{ nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }]
            },
            rotation: [{ nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }],
        })
    }

    saveRotation = async () => {
        /* Open Loading Icon */
        this.setState({ loadingSave: true })

        await updateARotationFromChamp(this.state.champId, this.state.rotationId, this.state.rotationTempObject);

        /* Close Loading Icon */
        this.setState({ loadingSave: false });
        message.success('Rodízio salvo com sucesso!');
    }

    render() {

        return (
            <RotationView
                champObject={this.state.champObject}
                champId={this.state.champId}

                rotationId={this.state.rotationId}
                loadingRotation={this.state.loadingRotation}
                isScoreMan={this.state.isScoreMan}
                rotation={this.state.rotation}
                ranking={this.state.ranking}
                arrayOfTeamsWithScore={this.state.arrayOfTeamsWithScore}
                loadingSave={this.state.loadingSave}
                addStudentManuallyDialog={this.state.addStudentManuallyDialog}
                filterPeso={this.state.filterPeso}
                filteredArrayOfStudents={this.state.filteredArrayOfStudents}
                loading={this.state.loading}

                clearRotation={() => this.clearRotation()}
                saveRotation={() => this.saveRotation()}
                putStudentInRotation={(e, x) => this.putStudentInRotation(e, x)}
                openScoreboard={(e1, e2, e3, e4) => this.openScoreboard(e1, e2, e3, e4)}
                scoreboard={this.state.scoreboard}
            />
        )
    }

}

export default Rotation